module.exports = __webpack_public_path__ + "img/NO981902122.27d9e9ab.svg";